import { call } from "goi_common";
import { useCrematoriumInquiryModal as useSharedCrematoriumInquiryModal } from "goi_common/src/design-system";

/**
 * platform 용 문의 모달. 발신은 call() 로 통일한다.
 * (새벽 2~7시 고이 번호 차단, PC alert, goi_call 액션 이벤트가 그대로 적용된다)
 *
 * @param eventPath 모달 안 5개 이벤트를 쏠 화면 path
 */
export const useCrematoriumInquiryModal = (
  eventPath: "crematorium_detail" | "crematorium_recommendation",
) => useSharedCrematoriumInquiryModal({ eventPath, onDial: (phoneNumber) => call(phoneNumber) });
